module.exports = __webpack_public_path__ + "static/6-51370f284ca9c5ef8ca8f395589632cf.jpg";